import axios from 'axios';
import unionWith from 'lodash/unionWith';
import isEqual from 'lodash/isEqual';
import clone from 'lodash/clone';
import cloneDeep from 'lodash/cloneDeep';

import { EmployeeNode } from '../../payroll-utils/employee-node';
import { categoriesAlias } from '../../payroll-utils/categories-alias'

const state = {
  employees: [],
  totals: [],
  detailsShown: null,
  loading: false,
}

const getters = {
  fields(state, getters) {
    return [
      { label:'N° de colaborador', key:'code' },
      { label:'Colaborador', key:'name' },
      { label: 'Puesto', key: 'job_title' },
    ]
    .concat(getters.categoryFields)
    .concat([
      { label:'Total', key:'total' }
    ])
    .map(field => ( {...field, thClass: 'border-0 bg-gray-100 text-gray-00', tdClass: 'border-gray text-gray-700' } ))
  },
  categoryFields(state) {
    return state.employees.reduce((fields, e) =>
      unionWith(fields, e.addendCategories.map(c => {
        var fullName = c.details.name;
        var name = fullName;
        if (typeof(categoriesAlias[c.details.id]) !== 'undefined')
          name = categoriesAlias[c.details.id];
        
        return { key: c.details.id, label: name, full: fullName }
      }), isEqual), []
    )
  },
}

const mutations = {
  setEmployees(state, employees) {
    state.employees = employees.breakdown.map(e => new EmployeeNode(e));
  },
  setTotals(state, employees) {
    state.totals = employees.acumulate_categories || [];
  },
  toggleShowDetails(state, { e, c }) {
    state.detailsShown[e][c] = !state.detailsShown[e][c];
  },
  createDetailsShown(state) {
    state.detailsShown = state.employees.reduce((o,e, i)=>{
      var p = clone(o)

      p[i] = e.addendCategories.reduce((l, b)=>{
        var q = clone(l)
        q[b.details.id] = false
        return q
      }, {})
      return p
    }, {})
  }
}

const actions = {
  async loadEmployees({ state, commit, rootState }) {
    state.loading = true;

    let response = await axios.get('/payroll', {
      params: {
        payroll_type: rootState.payrollClasification.payrollType,
        date: rootState.payrollClasification.date,
        end_date: rootState.payrollClasification.end_date,
        enterprise: rootState.payrollClasification.enterpriseId,
        area: rootState.payrollClasification.areaId,
        segmentId: rootState.payrollClasification.segmentId,
        groupId: rootState.payrollClasification.groupId,
      }
    });

    commit('setEmployees', cloneDeep(response.data));
    commit('setTotals', cloneDeep(response.data));
    commit('createDetailsShown');

    state.loading = false;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
